import { useFormContext } from 'react-hook-form';
import { Combobox, ComboboxProps } from '../components/Combobox/Combobox';
import { FormField } from './BaseFormComponents';
import { BaseFormFieldWrapper } from './BaseFormFieldWrapper';
import { FormComponentBaseProps } from './types/form-base-props';

export type FormComboboxProps<
  V extends string | string[] | null = string,
  T extends Record<string, unknown> = {},
> = FormComponentBaseProps &
  ComboboxProps<V, T> & {
    allowNullValue?: boolean;
    readOnly?: boolean;
  };

export const FormCombobox = <
  V extends string | string[] | null = string,
  T extends Record<string, unknown> = {},
>({
  description,
  descriptionProps,
  label,
  labelProps,
  hideError,
  defaultValue,
  name,
  disabled,
  readOnly,
  allowNullValue,
  required,
  onBack,
  value,
  Icon,
  ...props
}: FormComboboxProps<V, T>) => {
  const { control, formState } = useFormContext();
  const { isSubmitting } = formState;

  return (
    <FormField
      shouldUnregister={false}
      name={name}
      defaultValue={defaultValue}
      control={control}
      render={({ field }) => (
        <BaseFormFieldWrapper
          description={description}
          descriptionProps={descriptionProps}
          label={label}
          labelProps={labelProps}
          hideError={hideError}
          required={required}
          Icon={Icon}
        >
          <Combobox
            {...props}
            {...field}
            allowNullValue={allowNullValue}
            onBack={onBack}
            onValueChange={(val: V | null) => {
              field.onChange(val);
              props.onValueChange?.(val);
            }}
            disabled={disabled || isSubmitting || props.isLoading}
            readOnly={readOnly}
            value={value || field.value}
          />
        </BaseFormFieldWrapper>
      )}
    />
  );
};
